import styled, { css } from 'styled-components';
import { Card, Checkbox, View, Radio } from '@acin/ui-core';

export const CheckboxInput = styled(Checkbox)`
  margin-right: ${(p) => p.theme.spacing.getSize(2)};
  flex-shrink: 0;
  position: relative;
  top: 2px;
`;

export const RadioInput = styled(Radio)`
  margin-right: ${(p) => p.theme.spacing.getSize(2)};
  flex-shrink: 0;
  position: relative;
  top: 2px;
`;

// Backwards compatibility export
export const Input = CheckboxInput;

export const CheckboxCard = styled(Card)<{
  isActive?: boolean;
  onClick?: () => void;
}>`
  border: 1px solid ${(p) => p.theme.colors.borders.getValue(1)};
  border-radius: ${(p) => p.theme.spacing.getSize()};
  padding: ${(p) => p.theme.spacing.getSize(3)} ${(p) => p.theme.spacing.getSize(2)};
  display: flex;
  flex-direction: row;
  gap: ${(p) => p.theme.spacing.getSize()};
  align-items: flex-start;
  line-height: 1.5em;
  cursor: pointer;
  font-size: ${(p) => p.theme.type.getSize()};

  ${(p) =>
    !p.onClick &&
    css`
      cursor: default;
      padding-left: ${p.theme.spacing.getSize(6)};
    `}

  ${(p) =>
    p.isActive &&
    css`
      background: ${p.theme.colors.primary.getValue(100).main};
      border-color: ${p.theme.colors.primary.getValue(700).main};
    `}
`;

export const Content = styled(View)`
  display: flex;
  width: calc(100% - 28px);
`;
